import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Login from "./components/Login"
import Register from "./components/Register"
import NavBar from "./components/NavBar"
import UserPage from "./components/UserPage"
import Dashboard from "./components/Dashboard"
import UploadPage from "./components/UploadPage"
import TeamModule from "./components/TeamModule"
import UserList from "./components/UserList"
import PermissionsPanel from "./components/PermissionsPanel"
import Files from "./components/Files"
import FileType from "./components/FileType"
import ChangePassword from "./components/ChangePassword"
import ProtectedRoute from "./components/ProtectedRoute"
import ContainerStatus from "./components/ContainerStatus"

function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}
        <Route
          path="/user"
          element={
            <ProtectedRoute moduleName="User Dashboard">
              <UserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute moduleName="Admin Dashboard">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/uploadPage"
          element={
            <ProtectedRoute moduleName="Upload files module">
              <UploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/register"
          element={
            <ProtectedRoute moduleName="Register module">
              <Register />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teammodule"
          element={
            <ProtectedRoute moduleName="Teams module">
              <TeamModule />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute moduleName="Users list module">
              <UserList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/permissionspanel"
          element={
            <ProtectedRoute moduleName="Permission module">
              <PermissionsPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/files"
          element={
            // <ProtectedRoute moduleName="Files module">
            <Files />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/file-type"
          element={
            <ProtectedRoute moduleName="Files type module">
              <FileType />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute moduleName="Change Password module">
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="/container-status"
          element={
            <ProtectedRoute moduleName="Container Status module">
              <ContainerStatus />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
